import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

export default function AdminAuthWrapper({ children }) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  useEffect(() => {
    const verifyAuth = async () => {
      const token = localStorage.getItem("authToken");

      if (!token) {
        navigate("/login");
        return;
      }

      try {
        const { data } = await api.get(`${process.env.REACT_APP_API_BASE_URL}admin/verify`);

        if (data.valid) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem("authToken");
          navigate("/login");
        }
      } catch (error) {
        console.log(error);
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    };

    verifyAuth();
  }, [navigate]);

  if (isAuthenticated === null) return null; 

  return children;
}
